import React, { useState } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navigation from './Nav_Object';
import Navigationlink from './Navigation_items';
import { useLogout } from '../hooks/useLogout';
import { useAuthContext } from '../hooks/useAuthContext';
import { FiLogOut, FiMenu, FiX, FiChevronLeft, FiChevronRight } from 'react-icons/fi';

function Sidebar() {
  const { user } = useAuthContext();
  const { logout } = useLogout();
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sidebarCollapsed") === "true");

  if (!user) return null;

  const closeDrawer = () => setOpen(false);
  const toggleCollapsed = () => {
    setCollapsed((c) => {
      localStorage.setItem("sidebarCollapsed", String(!c));
      return !c;
    });
  };

  // `iconOnly` controls layout: collapsed on desktop, never on the mobile drawer.
  const renderInner = (iconOnly) => (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className={`flex items-center ${iconOnly ? "justify-center" : "justify-between"} px-3 py-5`}>
        {iconOnly ? (
          <span className="w-9 h-9 rounded-xl bg-gradient-to-br from-indigo-600 to-violet-600 text-white flex items-center justify-center">
            <i className="bi bi-lightning-charge-fill"></i>
          </span>
        ) : (
          <>
            <img src="/assets/Flash-logo-light.png" className="h-8 w-auto object-contain dark:hidden" alt="Content Flash AI" />
            <img src="/assets/Flash-logo-Dark.png" className="h-8 w-auto object-contain hidden dark:block" alt="Content Flash AI" />
          </>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto px-3 space-y-1">
        {Navigation.map((item) => (
          <Navigationlink key={item.id} {...item} collapsed={iconOnly} onNavigate={closeDrawer} />
        ))}
      </nav>

      {/* Footer */}
      <div className="p-3 border-t border-gray-100 dark:border-gray-800 space-y-1">
        {/* Collapse toggle — desktop only */}
        <button
          onClick={toggleCollapsed}
          className={`hidden md:flex w-full items-center ${iconOnly ? "justify-center px-0" : "gap-3 px-3"} py-2.5 rounded-xl text-sm font-medium font-Rajdhani text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white transition-colors`}
          title={iconOnly ? "Expand" : "Collapse"}
        >
          {iconOnly ? <FiChevronRight className="w-4 h-4" /> : <><FiChevronLeft className="w-4 h-4" /> Collapse</>}
        </button>
        <button
          onClick={logout}
          className={`w-full flex items-center ${iconOnly ? "justify-center px-0" : "gap-3 px-3"} py-2.5 rounded-xl text-sm font-medium font-Rajdhani text-gray-600 hover:bg-red-50 hover:text-red-600 dark:text-gray-300 dark:hover:bg-red-900/20 dark:hover:text-red-400 transition-colors`}
          title={iconOnly ? "Log out" : undefined}
        >
          <FiLogOut className="w-4 h-4" /> {!iconOnly && "Log out"}
        </button>
      </div>
    </div>
  );

  return (
    <>
      {/* Mobile top bar */}
      <div className="md:hidden sticky top-0 z-30 flex items-center justify-between h-14 px-4 bg-white/90 dark:bg-gray-900/90 backdrop-blur border-b border-gray-200 dark:border-gray-800">
        <img src="/assets/Flash-logo-light.png" className="h-7 w-auto object-contain dark:hidden" alt="Content Flash AI" />
        <img src="/assets/Flash-logo-Dark.png" className="h-7 w-auto object-contain hidden dark:block" alt="Content Flash AI" />
        <button onClick={() => setOpen(true)} className="p-2 text-gray-600 dark:text-gray-300 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800" aria-label="Open menu">
          <FiMenu className="w-6 h-6" />
        </button>
      </div>

      {/* Mobile overlay */}
      {open && <div className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden" onClick={closeDrawer} />}

      {/* Mobile drawer (always full width, never icon-only) */}
      <aside className={`fixed md:hidden top-0 z-50 h-screen w-64 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 transform transition-transform duration-200 ease-in-out ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <button onClick={closeDrawer} className="absolute top-4 right-3 p-1.5 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 rounded-lg" aria-label="Close menu">
          <FiX className="w-5 h-5" />
        </button>
        {renderInner(false)}
      </aside>

      {/* Desktop sidebar (collapsible) */}
      <aside className={`hidden md:block sticky top-0 h-screen flex-shrink-0 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 transition-[width] duration-200 ease-in-out ${collapsed ? "w-20" : "w-64"}`}>
        {renderInner(collapsed)}
      </aside>
    </>
  );
}

export default Sidebar;
